import React from "react";
import { Icon } from "aible";

import styles from "./style.module.css";

export default class ViewMessage extends React.PureComponent {
  render() {
    const { title, icon, children, className, ...retProps } = this.props;
    return (
      <div {...retProps} className={styles.viewMessage + " " + (className ? className : "")}>
        <div className={styles.viewMessageHeader}>
          {!icon || typeof icon === "string" ? <Icon type={icon || "info"} /> : icon}
          <div className={styles.viewMessageTitle}>{title}</div>
        </div>
        <div className={styles.viewMessageBody}>{children}</div>
      </div>
    );
  }
}
